var _circle, _circle2, _path, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardSecurecode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126 40",
    role: "img",
    "aria-label": "Mastercard SecureCode",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 14,
    r: 10,
    fill: "#EB001B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 14,
    r: 10,
    fill: "#F79E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5 A10 10 0 0 1 20 23 A10 10 0 0 1 20 5 Z",
    fill: "#FF5F00"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 15,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800,
    fontStyle: "italic",
    fontSize: 13,
    fill: "#EB001B"
  }, "MasterCard.")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 32,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800,
    fontStyle: "italic",
    fontSize: 12.5,
    fill: "#F79E1B"
  }, "Secure", /*#__PURE__*/React.createElement("tspan", {
    fill: "#4A4A4A"
  }, "Code"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardSecurecode);
export default __webpack_public_path__ + "static/media/mastercard-securecode.a4e86030e5b8bcec6c0a76fde9bfc823.svg";
export { ForwardRef as ReactComponent };